<template>
  <div
    class="wf-relative"
    :class="! previewMode ? 'wf-border wf-border-transparent hover:wf-border-blue-300 wf-py-4 wf-pb-2 wf-px-1' : ''"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <EditorOptions
      parent="component"
      v-show="hover && ! previewMode"
      :options="menuOptions"
      :parentModule="parentModule"
    />
    <div>
      <div :class="elementClasses(classes('featuredContainerClasses'))" v-show="content.featured">
        <div
          :contenteditable="! previewMode"
          class="wf-inline-block wf-relative wf-z-50"
          :class="elementClasses(classes('featuredClasses'))"
          :style="elementStyles(styles('featuredStyles'))"
          v-text="content.featuredText"
          @input="updateContentProperty('featuredText', $event.target.textContent)"
        ></div>
      </div>
      <div class="wf-overflow-hidden" :class="elementClasses(classes('classes'), classes('customClasses'))" :style="elementStyles(styles('styles'))">
        <draggable
          group="pricingTableBlocks"
          v-model="headerBlocks"
          handle=".pricing-table-block-handle"
          :class="elementClasses(classes('headerClasses'))"
          :style="elementStyles(styles('headerStyles'))"
        >
          <component
            v-show="block.show"
            @input="updateBlock($event, block.component)"
            v-for="block in headerBlocks"
            :key="block.component"
            :is="block.component"
            :containerClasses="block.containerClasses"
            :classes="block.classes"
            :styles="block.styles"
            :value="block.value"
            :recurrency="block.recurrency"
            :iconStyles="block.iconStyles"
            :iconClasses="block.iconClasses"
          />
        </draggable>
        <draggable
          group="pricingTableBlocks"
          v-model="contentBlocks"
          handle=".pricing-table-block-handle"
          :class="elementClasses(classes('contentClasses'))"
          :style="elementStyles(styles('contentStyles'))"
        >
          <component
            v-show="block.show"
            @input="updateBlock($event, block.component)"
            v-for="block in contentBlocks"
            :key="block.component"
            :is="block.component"
            :containerClasses="block.containerClasses"
            :classes="block.classes"
            :styles="block.styles"
            :value="block.value"
            :recurrency="block.recurrency"
            :iconStyles="block.iconStyles"
            :iconClasses="block.iconClasses"
          />
        </draggable>
        <draggable
          group="pricingTableBlocks"
          v-model="footerBlocks"
          handle=".pricing-table-block-handle"
          :class="elementClasses(classes('footerClasses'))"
          :style="elementStyles(styles('footerStyles'))"
        >
          <component
            v-show="block.show"
            @input="updateBlock($event, block.component)"
            v-for="block in footerBlocks"
            :key="block.component"
            :is="block.component"
            :containerClasses="block.containerClasses"
            :classes="block.classes"
            :styles="block.styles"
            :value="block.value"
            :recurrency="block.recurrency"
            :iconStyles="block.iconStyles"
            :iconClasses="block.iconClasses"
          />
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import PricingTableListBlock from './PricingTableListBlock'
  import PricingTableTitleBlock from './PricingTableTitleBlock'
  import PricingTablePriceBlock from './PricingTablePriceBlock'
  import PricingTableButtonBlock from './PricingTableButtonBlock'
  import EditorComponent from '../contracts/EditorComponent'
  import PricingTableDescriptionBlock from './PricingTableDescriptionBlock'
  export default EditorComponent.extend({
    components: {
      draggable,
      PricingTableButtonBlock,
      PricingTableListBlock,
      PricingTableTitleBlock,
      PricingTablePriceBlock,
      PricingTableDescriptionBlock
    },
    computed: {
      componentBlocks() {
        return {
          PricingTableTitleBlock: {
            show: this.content.hasTitle,
            component: 'PricingTableTitleBlock',
            containerClasses: this.elementClasses(this.classes('titleContainerClasses')),
            classes: this.elementClasses(this.classes('titleClasses')),
            styles: this.elementStyles(this.styles('titleStyles')),
            value: this.content.title
          },
          PricingTablePriceBlock: {
            show: true,
            component: 'PricingTablePriceBlock',
            containerClasses: this.elementClasses(this.classes('priceContainerClasses')),
            classes: this.elementClasses(this.classes('priceClasses')),
            styles: this.elementStyles(this.styles('priceStyles')),
            value: this.content.price,
            recurrency: this.content.recurrency,
          },
          PricingTableDescriptionBlock: {
            show: this.content.hasDescription,
            component: 'PricingTableDescriptionBlock',
            containerClasses: this.elementClasses(this.classes('descriptionContainerClasses')),
            classes: this.elementClasses(this.classes('descriptionClasses')),
            styles: this.elementStyles(this.styles('descriptionStyles')),
            value: this.content.description,
          },
          PricingTableListBlock: {
            show: this.content.hasList,
            component: 'PricingTableListBlock',
            classes: this.elementClasses(this.classes('listClasses')),
            styles: this.elementStyles(this.styles('listStyles')),
            value: this.content.listItems,
            iconClasses: [...this.elementClasses(this.classes('iconClasses')), this.content.icon, this.content.class, 'wf-mr-2'],
            iconStyles: this.elementStyles(this.styles('iconStyles')),
          },
          PricingTableButtonBlock: {
            show: true,
            component: 'PricingTableButtonBlock',
            classes: this.elementClasses(this.classes('buttonClasses')),
            styles: this.elementStyles(this.styles('buttonStyles')),
            value: this.content.buttonText,
          },
        }
      },
      headerBlocks:{
        get() {
          let blocks = this.content.headerBlocks
          return blocks.map(block => this.componentBlocks[block])
        },
        set(value) {
          let headerBlocks = value.map(valueBlock => valueBlock.component)
          this.addToObject(this.module, {headerBlocks}, 'content')
        }
      },
      contentBlocks:{
        get() {
          let blocks = this.content.contentBlocks
          return blocks.map(block => this.componentBlocks[block])
        },
        set(value) {
          let contentBlocks = value.map(valueBlock => valueBlock.component)
          this.addToObject(this.module, {contentBlocks}, 'content')
        }
      },
      footerBlocks:{
        get() {
          let blocks = this.content.footerBlocks
          return blocks.map(block => this.componentBlocks[block])
        },
        set(value) {
          let footerBlocks = value.map(valueBlock => valueBlock.component)
          this.addToObject(this.module, {footerBlocks}, 'content')
        }
      }
    },
    methods: {
      updateBlock(event, component) {
        if (component == 'PricingTableListBlock') {
          return this.updateContentProperty('listItems', event)
        }
        if (component == 'PricingTableButtonBlock') {
          return this.updateContentProperty('buttonText', event)
        }
        if (component == 'PricingTableTitleBlock') {
          return this.updateContentProperty('title', event)
        }
        if (component == 'PricingTableDescriptionBlock') {
          return this.updateContentProperty('description', event)
        }
        if (component == 'PricingTablePriceBlock') {
          return this.updateContentProperty('price', event)
        }
      }
    },
  })
</script>